<template>
  <div class="step-two-box">
    <div class="class-table">
      <div class="table-left-box">
        <div class="name">课程商品</div>
        <div class="table-left smart-scroll">
          <div
            v-for="(item, index) in classGoodsList"
            :key="item.productId"
            class="table-left-item"
            :class="index === activeGoodsIndex ? 'table-left-item-active' : ''"
            @click="handleChangeLeftActive(index)"
          >
            <!-- <Tooltip max-width="250" :content="`${item.productName}（${item.studentTotal}人）`">
              <div class="name-content"><span class="left-name">{{ item.productName }}</span><span>（{{ item.studentTotal }}人）</span></div>
            </Tooltip> -->
            <div class="name-content">
              <span class="left-name">{{ item.productName }}（{{ item.studentTotal }}人）</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="classGoodsList.length > 0" class="table-right">
        <div class="content-top">
          <Select v-model="activeViewType" class="top-select">
            <Option
              v-for="item in viewTypeArr"
              :key="item.value"
              :value="item.value"
            >{{ item.lable }}</Option>
          </Select>
          <Input
            v-model="studentName"
            search
            class="top-search"
            placeholder="输入学生姓名搜索"
            @on-search="handleSearchStudent"
          ></Input>
          <Button
            v-if="searchStudentArr.length > 1"
            @click="handleSeachNext"
          >查找下一个({{ searchActive + 1 }}/{{
            searchStudentArr.length
          }})</Button>
          <span v-if="haveSearchResult && searchStudentArr.length === 0">暂无该学生</span>
        </div>
        <SmartStudentTable
          v-show="activeViewType === '1'"
          ref="smartStudentTable"
          v-model="classGoodsList[activeGoodsIndex].details"
          :school-id="schoolId"
          :branch-id="branchId"
          :org-id="classGoodsList[activeGoodsIndex].orgId"
          :search-student-id="searchStudentId"
          :active-class-index.sync="activeClassIndex"
          :active-goods-index="activeGoodsIndex"
          @showChangeModal="handleShowChangeModal"
        ></SmartStudentTable>
        <SmartClassTable
          v-show="activeViewType === '2'"
          v-model="classGoodsList[activeGoodsIndex].details"
          :school-id="schoolId"
          :branch-id="branchId"
          :org-id="classGoodsList[activeGoodsIndex].orgId"
          :active-class-index.sync="activeClassIndex"
          :active-goods-index="activeGoodsIndex"
          @showChangeModal="handleShowChangeModal"
        ></SmartClassTable>
      </div>
    </div>
    <div class="btn-box">
      <Button @click="handleBackStep">上一步，分班确认</Button>
      <Button
        :disabled="btnDisabled"
        type="primary"
        @click="handleSubmitClass"
      >保存，确定成班</Button>
    </div>
    <Modal
      v-model="showChangeClassModal"
      :width="600"
      title="转班提示"
      :footer-hide="true"
    >
      <div
        v-if="
          classGoodsList.length > 0 &&
            classGoodsList[activeGoodsIndex].details.length > 1
        "
      >
        <div class="alert-box">
          可将学生转班至其他关联<span>相同课程</span>商品的分班中
        </div>
        <div class="class-content">
          <div
            v-for="(item, index) in classGoodsList[activeGoodsIndex].details"
            :key="index"
            class="content-item-box"
          >
            <div v-if="index !== activeClassIndex" class="content-item">
              <div class="item-left">
                <div class="student-info">
                  {{ item.className }}
                  <span class="student-num">（{{ item.studentInfos.length }}人）</span>
                </div>
                <!-- <div class="class-time">{{ item.timeDesc }}</div> -->
              </div>
              <Button type="primary" @click="handleToChangeStudent(index)">
                转入
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="alert-box">可将学生转班至其他关联相同课程商品的分班中</div>
        <div class="list-null">
          <Icon type="ios-sad-outline" :size="56"></Icon>
          <span>无班级可转入</span>
        </div>
      </div>
    </Modal>
    <div class="modal-box-smart">
      <Modal
        v-model="loadingShow"
        :width="300"
        title=""
        :footer-hide="true"
        :closable="false"
        :mask-closable="false"
      >
        正在分班中...
      </Modal>
    </div>
  </div>
</template>
<script>
import SmartStudentTable from './SmartStudentTable.vue';
import SmartClassTable from './SmartClassTable.vue';
import { timeToStr } from '@/utils/utils.js';
import { weekList, changeDictionaries } from '@/utils/dictionary.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
export default {
  components: {
    SmartStudentTable,
    SmartClassTable
  },
  props: {
    previewParams: {
      type: Object,
      default: () => {
        return {
          smartPartitionType: 1
        };
      }
    }, // 获取分班预览需要传递过去的参数
    productIds: {
      type: Object,
      default: () => {
        return {
          '711523894686658561': {
            startTime: '2022-12-01',
            weekCycleNum: 1,
            limitOfStuNum: 20
          }
        };
      }
    }, // 用户选择的商品
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    branchId: {
      type: String,
      default: ''
    } // 校区id
  },
  data() {
    return {
      activeViewType: '1', // 展示类型
      studentName: '', // 学生姓名
      viewTypeArr: [
        {
          value: '1',
          lable: '按学生显示'
        }, {
          value: '2',
          lable: '按行政班显示'
        }
      ],
      loadingShow: false, // 是否展示loading
      classGoodsList: [], // 左侧的商品列表
      checkAllGroup: [],
      activeGoodsIndex: 0, // 选中的商品
      activeClassIndex: 0, // 选中的班级
      showChangeClassModal: false, // 转班提示弹窗是否展示
      studentIdArr: [], // 要转班的学生列表
      searchStudentArr: [],
      searchActive: 0,
      searchStudentId: '',
      haveSearchResult: false, // 是否搜索到结果了
      weekListValue: changeDictionaries(weekList),
      btnDisabled: false // 确定成班按钮是否可以点击
    };
  },
  watch: {
    // studentName(newVal){
    //   if(newVal===''){

    //   }
    // },
    activeViewType() {
      this.classGoodsList[this.activeGoodsIndex].details.map(item => {
        // item.teacherInfo = item.teacherInfoCopy;
        // item.placeInfo = item.placeInfoCopy;
        return item;
      });
    }
  },
  created() {
    this.getMoreGoodsCourseClassPreview();
  },
  methods: {
    // 返回上一页
    handleBackStep() {
      // this.sureDivide();
      // return;
      this.$eventHub.$emit('backStep', {
        type: 'cancel',
        data: {
          previewParams: this.previewParams
          // startTime: this.startTime,
          // weekCycleNum: this.weekCycleNum,
          // tabType: this.tabType
        }
      });
    },
    handleChangeLeftActive(index) {
      this.activeGoodsIndex = index;
    },
    // 获取商品id列表
    getProductIdsList() {
      const arr = Object.keys(this.productIds).map(item => {
        const obj = {
          productId: item,
          limitOfStuNum: this.productIds[item].limitOfStuNum
        };
        return obj;
      });
      return arr;
    },
    // 获取分班预览多商品
    async getMoreGoodsCourseClassPreview() {
      this.loadingShow = true;
      const params = Object.assign({}, this.previewParams, { smartPartitionPreviewMoreRoList: this.getProductIdsList() });
      const res = await courseSchedulCenter.postSmartClassPreviewMoreGooodsApi(params);

      if (res.status === 200) {
        console.log(this.previewParams.smartPartitionType, '拿到的选择类型');
        this.classGoodsList = res.message.map(item => {
          item.timeDesc = item.arrangingRuleBO ? this.dealTimeList(item.arrangingRuleBO) : '';
          item.details.map((x, y) => {
            console.log(x.studentInfos);

            const { obj, className } = this.dealStudentsByClass(x.studentInfos);
            console.log(obj, className, '拿到的问题-----32432');
            x.classStudentInfo = obj;
            // x.className = +this.previewParams.smartPartitionType === 2 ? `${item.productName} - ${className}` : `${item.productName} - ${y + 1}班`;
            if (+this.previewParams.smartPartitionType === 2) {
              x.className = `${item.productName} - ${className}`;
            } else {
              x.className = item.details.length === 1 ? `${item.productName}` : `${item.productName} ${y + 1}班`;
            }
            x.placeInfo = item.placeInfo ? item.placeInfo : { placeId: '', placeName: '' };
            // x.placeInfoCopy = item.placeInfo;
            // x.placeId = item.placeInfo ? item.placeInfo.placeId : '';
            x.teacherInfo = item.teacherInfo;
            // x.teacherInfoCopy = item.teacherInfo;
            x.teacherIds = item.teacherInfo.map(i => {
              return i.teacherId;
            });
            x.arrangingRuleBO = item.arrangingRuleBO;
            x.timeDesc = item.timeDesc;
            return x;
          });
          item.studentTotal = item.details.reduce(
            (previousValue, currentValue) => {
              return previousValue + currentValue.studentInfos.length;
            },
            0
          );
          console.log(item.details);
          return item;
        });
        this.loadingShow = false;
      } else {
        this.loadingShow = false;
      }
    },
    // 处理上课时间的展示
    dealTimeList(timeInfo) {
      let timeStr = '';
      timeInfo.schoolTimeList.forEach((x, y) => {
        const classBegin = timeToStr(x.classTimeBegin);
        const classEnd = timeToStr(x.classTimeEnd);
        if (timeInfo.ruleType === 1) {
          timeStr += `${this.weekListValue[x.weekDate ? x.weekDate : 0]}`;
        } else {
          timeStr += `${this.weekListValue[x.weekDate ? x.weekDate : 0]
          } （${classBegin}-${classEnd}）`;
        }
        if (y < timeInfo.schoolTimeList.length - 1) {
          timeStr += '、';
        }
        if (y === timeInfo.schoolTimeList.length - 1 && timeInfo.ruleType === 1) {
          timeStr += `（${classBegin}-${classEnd}） `;
        }
      });
      return timeStr;
    },
    // 把学生按不同班级分在一起
    dealStudentsByClass(studentInfos) {
      console.log(studentInfos, '学生信息-====433');
      let classId = '';
      let className = '';
      const obj = {};
      studentInfos.forEach(item => {
        if (item.classId !== classId) {
          classId = item.classId;
          obj[classId] = {
            list: [item],
            className: item.gradeName + item.className
          };
          className = item.gradeName + item.className;
        } else {
          obj[item.classId].list.push(item);
        }
      });

      return { obj, className };
    },
    handleShowChangeModal(studentIdArr) {
      this.studentIdArr = studentIdArr;
      this.showChangeClassModal = true;
    },
    // 对学生进行转班
    handleToChangeStudent(index) {
      const originClass = this.classGoodsList[this.activeGoodsIndex].details[this.activeClassIndex].studentInfos;
      const finishClass = this.classGoodsList[this.activeGoodsIndex].details[index].studentInfos;
      // const changeClassStudents = [];
      console.log(this.studentIdArr, '转班的学生===信息====');
      this.studentIdArr.forEach(item => {
        const studentIndex = originClass.findIndex(x => {
          return x.studentId === item;
        });
        console.log(studentIndex, '拿到了第几个', originClass[studentIndex]);
        finishClass.push(originClass[studentIndex]);
        originClass.splice(studentIndex, 1);
      });
      this.classGoodsList = this.classGoodsList.map(item => {
        item.details.map((x, y) => {
          const { obj } = this.dealStudentsByClass(x.studentInfos);
          x.classStudentInfo = obj;
          return x;
        });
        return item;
      });
      this.showChangeClassModal = false;
      if (originClass.length === 0) {
        this.$Modal.confirm({
          title: '提示',
          content: '该班级已无学生，是否删除该班级？',
          onOk: () => {
            this.classGoodsList[this.activeGoodsIndex].details.splice(this.activeClassIndex, 1);
            if (this.activeClassIndex >= this.classGoodsList[this.activeGoodsIndex].details.length) {
              this.activeClassIndex = 0;
            }
            if (this.activeViewType === '1') {
              this.$refs.smartStudentTable.handleChangeClass(this.activeClassIndex);
            }
          }
        });
      } else if (this.activeViewType === '1') {
        this.$refs.smartStudentTable.handleChangeClass(this.activeClassIndex);
      }
    },
    // 搜索学生
    handleSearchStudent() {
      this.activeViewType = '1';
      this.searchStudentArr = [];
      this.searchActive = 0;
      this.searchStudentId = '';
      this.haveSearchResult = false;
      if (this.studentName === '') {
        return;
      }
      this.classGoodsList[this.activeGoodsIndex].details.forEach((item, index) => {
        item.studentInfos.forEach(x => {
          if (x.studentName.indexOf(this.studentName) !== -1) {
            const obj = {
              activeClassIndex: index,
              studentId: x.studentId
            };
            this.searchStudentArr.push(obj);
          }
        });
      });
      this.haveSearchResult = true;
      if (this.searchStudentArr.length > 0) {
        this.activeClassIndex = this.searchStudentArr[0].activeClassIndex;
        this.searchActive = 0;
        this.searchStudentId = this.searchStudentArr[0].studentId;
      }
      this.$nextTick(() => {
        this.scrollToActiveItem();
      });
    },
    scrollToActiveItem() {
      document.querySelector('.tableshow-student .student-right-content').scrollTop = document.getElementsByClassName('student-table-item-active')[0].offsetTop;
      console.log(document.getElementsByClassName('student-table-item-active')[0].offsetTop);
    },
    handleSeachNext() {
      this.searchActive += 1;
      if (this.searchActive === this.searchStudentArr.length) {
        this.searchActive = 0;
      }
      this.activeClassIndex = this.searchStudentArr[this.searchActive].activeClassIndex;
      this.searchStudentId = this.searchStudentArr[this.searchActive].studentId;
      this.$nextTick(() => {
        this.scrollToActiveItem();
      });
    },
    // 提交智能分班数据,第一步，处理数据
    handleSubmitClass() {
      const smartPartitionMoreRoList = this.classGoodsList.map(item => {
        const items = [];
        item.details.forEach(x => {
          // studentId 改成 取 enrollId
          const studentIds = x.studentInfos.map(i => {
            return i.enrollId;
          });
          const { placeId, placeName } = x.placeInfo;
          // if (placeName !== '' && placeName === placeId) {
          //   placeId = 0;
          // }
          const itemsObj = {
            className: x.className,
            // placeId,
            placeName,
            // studentIds 修改成 enrollIds
            enrollIds: studentIds
            // teacherSignRuleBo: {
            //   ruleType: 1, // 这里默认自由打卡 打卡规则类型 1-自由打卡 2-单双周不同教师 3-单双周相同教
            //   teacherIds: x.teacherIds, // 教师id
            //   signRulesCycle: null// 签到规则 自由打卡为null
            // }
          };
          // placeName ? itemsObj.placeName = placeName : '';
          if (x.teacherIds.length > 0) {
            itemsObj.teacherSignRuleBo = {
              ruleType: 1, // 这里默认自由打卡 打卡规则类型 1-自由打卡 2-单双周不同教师 3-单双周相同教
              teacherIds: x.teacherIds, // 教师id
              signRulesCycle: null// 签到规则 自由打卡为null
            };
          }
          items.push(itemsObj);
        });
        const obj = {
          productId: item.productId,
          weekCycleNum: this.productIds[item.productId].weekCycleNum,
          startTime: `${this.productIds[item.productId].startTime} 00:00:00`,
          items
        };
        return obj;
      });
      this.submitSmartClass(smartPartitionMoreRoList);
    },
    async submitSmartClass(smartPartitionMoreRoList) {
      try {
        const params = {
          smartPartitionMoreRoList
        };
        this.btnDisabled = true;
        this.$Spin.show();
        const res = await courseSchedulCenter.postSmartPartitionMoreApi(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$eventHub.$emit('divideTaskStart', res.message);
        }
      } catch (err) {
        console.log(err, '错误');
      } finally {
        this.btnDisabled = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.smart-scroll {
  scrollbar-width: thin; //火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细
  &::-webkit-scrollbar {
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    width: 4px;
    height: 60px;
    background: rgba(0, 0, 0, 0.15);
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: rgba(255, 255, 255, 0);
  }
}
.step-two-box {
  .class-table {
    height: calc(100vh - 400px);
    border: 1px solid #dcdee2;
    border-radius: 2px;
    margin-top: 24px;
    display: flex;
    .table-left-box {
      width: 240px;
      height: 100%;
      border-radius: 2px;
      border-right: 1px solid #dcdee2;
      background: #f7f7f9;
      .name {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #dcdee2;
        font-weight: 600;
      }
    }
    .table-left {
      width: 100%;
      height: calc(100% - 40px);
      overflow-y: auto;
      scrollbar-width: thin;
      .table-left-item {
        box-sizing: border-box;
        position: relative;
        padding: 12px;
        min-height: 48px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        cursor: pointer;
        .name-content {
          display: flex;
          align-items: center;
          // .left-name{
          //   max-width: 180px;
          //   word-break: break-all;
          //   text-overflow: ellipsis;
          //   display: -webkit-box;
          //   -webkit-box-orient: vertical;
          //   -webkit-line-clamp: 1;
          //   overflow: hidden;
          // }
        }
      }
      .table-left-item::before {
        content: '';
        position: absolute;
        top: 50%;
        margin-top: -12px;
        left: 0;
        width: 4px;
        height: 24px;
      }
      .table-left-item-active {
        background: #fff;
        font-weight: 600;
        color: #488ffa;
        &::before {
          background: #488ffa;
        }
      }
    }
    .table-right {
      flex: 1;
      box-sizing: border-box;
      padding: 16px 0 16px 24px;
      .content-top {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .top-select {
          width: 122px;
          margin-right: 24px;
        }
        .top-search {
          width: 256px;
          margin-right: 8px;
        }
      }
    }
  }
}
.btn-box {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 180px;
  height: 64px;
  background-color: #fff;
  border-top: 1px solid #ececee;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  Button + Button {
    margin-left: 40px;
  }
}
.alert-box {
  border: 1px solid #488ffa;
  width: 100%;
  padding: 8px 0;
  text-align: center;
  color: #488ffa;
  background: #efecfd;
  border-radius: 4px;
  margin-bottom: 8px;
  font-size: 16px;
  span {
    color: #ed4014;
  }
}
.content-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  .item-left {
    margin-right: auto;
    .student-info {
      font-size: 16px;
    }
    .student-num {
      margin-left: 8px;
      font-size: 12px;
      color: #ccc;
    }
    .class-time {
      font-size: 12px;
      color: #ccc;
    }
  }
}
.modal-box-smart {
  /deep/.ivu-modal-content {
    width: 300px;
    height: 300px;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
